import { render } from "./IteratorDiagramComponent.vue?vue&type=template&id=70b8fd3d&scoped=true"
const script = {}

import "./IteratorDiagramComponent.vue?vue&type=style&index=0&id=70b8fd3d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b8fd3d"]])

export default __exports__